import { createUUID } from "sb-helpers";
export const MessageChannels = {
    Unsubscribe: "Unsubscribe",
    GetSports: "GetSports",
    GetSportsGroupedByDate: "GetSportsGroupedByDate",
    GetLeaguesBySportId: "GetLeaguesBySportId",
    GetLeaguesByLeagueId: "GetLeaguesByLeagueId",
    GetTopLeaguesBySportId: "GetTopLeaguesBySportId",
    GetEventsBySportId: "GetEventsBySportId",
    GetEventsByEventId: "GetEventsByEventId",
    GetEventsByEventIdOrByLeagueId: "GetEventsByEventIdOrByLeagueId",
    GetEventsByLeagueId: "GetEventsByLeagueId",
    GetEventsFromTopLeaguesBySportId: "GetEventsFromTopLeaguesBySportId",
    GetEventsCountByTag: "GetEventsCountByTag",
    GetEventsByRegionIdAndSportId: "GetEventsByRegionIdAndSportId",
    GetPersonalizedLiveEvents: "GetPersonalizedLiveEvents",
};
export var SupportedMessageFormats;
(function (SupportedMessageFormats) {
    SupportedMessageFormats["jsonrpc2.0"] = "jsonrpc2.0";
})(SupportedMessageFormats || (SupportedMessageFormats = {}));
;
export const MessageChannelsToIds = Object
    .keys(MessageChannels)
    .reduce((a, b) => {
    a[b] = createUUID();
    return a;
}, {});
export const MessageChannelsIdToChannel = Object
    .keys(MessageChannelsToIds)
    .reduce((a, b) => {
    a[MessageChannelsToIds[b]] = b;
    return a;
}, {});
//# sourceMappingURL=message.js.map